import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const SUPPLIER_FACILITY_REVIEWS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator(
	'SUPPLIER_FACILITY_REVIEWS'
);
export const SUPPLIER_FACILITY_REVIEWS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	SUPPLIER_FACILITY_REVIEWS_CRUD_ACTION_CONSTANTS
);
